import React, { useState } from 'react'
import styled from 'styled-components'
import { get } from 'lodash'
import { AiOutlineMessage } from 'react-icons/ai'

import { RemarkModal } from './remark-modal'
import { revenueType } from '../../../constants'
import { FONTS } from '../../../../../../../constants'

export const InputThirdRow = React.memo(({
  isEdit,
  data,
  allocation_id,
  id,
  lobData,
  handleChangeRemark,
}) => {
  const lobAllocation = get(data, 'lobs', [])[id]
  const { resource_price } = lobAllocation
  const [openRemarkModal, setOpenRemarkModal] = useState(false)

  const handleClickRemark = () => {
    setOpenRemarkModal(!openRemarkModal)
  }

  const handleRemark = e => {
    handleChangeRemark(e, allocation_id, id, 'remark')
  }

  return (
    <Root>
      { openRemarkModal &&
      <RemarkModal
        isOpen={ openRemarkModal }
        data={ data }
        isEdit={ isEdit }
        lobData={ lobData }
        lobAllocation={ lobAllocation }
        toggle={ handleClickRemark }
        handleRemark={ handleRemark }
      />
      }
      <RemarkWrapper onClick={ handleClickRemark }>
        <AiOutlineMessage style={ { color: '#2D9CDB', marginRight: 8 } } />
        <RemarkText>Remark</RemarkText>
      </RemarkWrapper>
      <FormWrapper>
        <Label>Service Contract Price</Label>
        <Price>
          { revenueType[data.type].resources_price ? `฿ ${resource_price}` : '-' }
        </Price>
      </FormWrapper>
      <EmptyCol />
    </Root>
  )
})

const Root = styled.div`
  height: 40px;
  display: flex;
`

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  :nth-child(1) {
      padding-right: 6px;
  }

  :nth-last-child(1) {
      padding-left: 6px;
  }
`

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #808080;

  ${p => p.required && `
    ::after {
      content: '*';
      color: red;
    }
  `}
`

const Price = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`

const RemarkWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  cursor: pointer;
`

const RemarkText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #2D9CDB;
`

const EmptyCol = styled.div`
  flex: 1;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/revenue-table/item/project-detail/input-third-row.js